/**
 * Chameleon icon — custom inline SVG for the CamelionAI brand mark.
 * Stylized side-profile silhouette with the signature curled tail.
 * Inherits `currentColor` so it picks up the Money Green from CSS vars.
 */
export default function ChameleonIcon({ size = 20, className = "", strokeWidth = 1.6 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      {/* body + head — flowing left-facing silhouette */}
      <path d="M2.4 13.8c0-3 2.6-5 5.4-5h6.5c1.4 0 2.5-.7 3.4-1.7l1.7-1.9c.4-.5 1.2-.3 1.4.3.7 2.2.1 4.6-1.6 6.1l-1.1 1" />
      {/* back ridge dorsal crest */}
      <path d="M5.5 9.5l.6-1.3M8 9l.6-1.3M10.5 8.7l.6-1.3" />
      {/* legs */}
      <path d="M6.5 14v3.5M11 14v3M15 14v2.5" />
      {/* curled tail */}
      <path d="M18.5 12.6c.9 1 1.4 2.3 1.4 3.6 0 1.6-.9 2.8-2.2 2.8s-2.2-1-2.2-2.2c0-.9.6-1.6 1.4-1.6.6 0 1 .4 1 .9" />
      {/* eye */}
      <circle cx="18.2" cy="8.9" r="0.55" fill="currentColor" />
    </svg>
  );
}
